import { useEffect } from 'react';
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { CasesGeneralNotification } from '../../../../../../shared/types/modules/cases-general';
import { CasesGeneralNotificationProps } from './props';
import { asyncGetAccount } from '../../../../../../services/accounts.service';
import { useNavigate } from 'react-router-dom';
import { CASES_GENERAL } from '../../../../../../routes/paths';

export const useCasesGeneralNotification = ({
    data,
    onChangeData,
    onChangeFormik,
    idAccount,
}: CasesGeneralNotificationProps) => {
    const notificationClient = '';
    const navigate = useNavigate();
    const onSubmit = (data: CasesGeneralNotification) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue(
            'notificationClient',
            data?.notificationClient || formik.values.notificationClient
        );
    }, [data]);

    useEffect(() => {
        if (Boolean(idAccount?.trim()))
            asyncGetAccount(idAccount || '').then((data) => {
                if (!data || !data.id || !data.email) navigate(CASES_GENERAL);
                formik?.setFieldValue('notificationClient', data?.email || '');
            });
    }, []);

    return {
        formik,
        notificationClient,
    };
};
